// extracted by mini-css-extract-plugin
export var relatedProducts = "ProductRelatedProduct-module--relatedProducts--sd6nV";
export var inner = "ProductRelatedProduct-module--inner--3i-+n";
export var logo = "ProductRelatedProduct-module--logo--k6-sx";
export var relatedProduct = "ProductRelatedProduct-module--relatedProduct--eItC6";
export var singleProduct = "ProductRelatedProduct-module--singleProduct--hy1kt";
export var boxButton = "ProductRelatedProduct-module--boxButton--7Ye60";
export var innerButton = "ProductRelatedProduct-module--innerButton--udQ8V";
export var iconContainer = "ProductRelatedProduct-module--iconContainer--NBoCY";
export var boxWrapper = "ProductRelatedProduct-module--boxWrapper--8iISi";